// eslint-disable-next-line no-restricted-imports -- TODO()
import "@sendbird/uikit-react/dist/index.css";

import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";
import { type Worker } from "@src/appV2/Worker/api/types";
import { type ReactElement, type ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import {
  DeploymentEnvironmentName,
  environmentConfig,
  isProductionNodeEnvironment,
} from "../environment";

interface ChatProviderProps {
  userId: string;
  worker: Worker;
  accessToken: string;
  children: ReactNode;
}

export function ChatProvider(props: ChatProviderProps): ReactElement {
  const { children, userId, worker, accessToken } = props;
  const location = useLocation();
  const [connectToChatInLowerEnvironments, setConnectToChatInLowerEnvironments] = useState(false);

  // We only want to set the appId in production or if the chat page is actively being visited, else this increases the usage of sendbird connections
  // Due to this change, the chat counter will not be updated in the app bar when the user has not visited the chat page
  useEffect(() => {
    if (
      location.pathname.includes("/chat") ||
      location.pathname.includes("/clipboard-guides-chat")
    ) {
      setConnectToChatInLowerEnvironments(true);
    }
  }, [location.pathname]);

  const appId =
    (isProductionNodeEnvironment() &&
      environmentConfig.REACT_APP_ENVIRONMENT_NAME === DeploymentEnvironmentName.PRODUCTION) ||
    connectToChatInLowerEnvironments
      ? environmentConfig.REACT_APP_SENDBIRD_APP_ID
      : "";

  return (
    <SendbirdProvider
      appId={appId}
      userId={userId}
      nickname={worker.name}
      accessToken={accessToken}
    >
      {children}
    </SendbirdProvider>
  );
}
